import { axios } from 'lib/axios';
import { useQuery } from 'react-query';

export const getBaseRate = ({ baseCurrency, quoteCurrency }) => {
  return axios.get(`/rate/baseRate/${baseCurrency}/${quoteCurrency}`);
};

export const useBaseRate = ({ baseCurrency, quoteCurrency, config }) => {
  return useQuery({
    ...config,
    queryKey: ['currencyManualBankProviders', baseCurrency, quoteCurrency],
    queryFn: () => getBaseRate({ baseCurrency, quoteCurrency }),
  });
};
